import React, { useEffect } from "react";
import { CONFIG } from "../config";
import { useAppState } from "../context/AppContext";
import { excelLinesToOrderLines } from "../lib/excelTransformers";

type Props = {
  noInitialLoad?: boolean;
};

export const useLoadLocalOrderLines = (props?: Props) => {
  const { dispatch } = useAppState();

  const loadData = async () => {
    await Excel.run(async (context) => {
      const worksheet = context.workbook.worksheets.getItem(CONFIG.ORDER_SHEET_NAME);
      const allRows = worksheet.getUsedRange();
      allRows.load("values");
      await context.sync();
      allRows.values.shift();
      dispatch(["SET_ORDERS", { orderLines: excelLinesToOrderLines(allRows.values) }]);
    });
  };

  useEffect(() => {
    if (!props?.noInitialLoad) {
      void loadData();
    }
  }, []);

  return { reload: loadData };
};
